import { render } from "./ReportHazards.vue?vue&type=template&id=5c870805"
import script from "./ReportHazards.vue?vue&type=script&lang=js"
export * from "./ReportHazards.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Reports/ReportHazards.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c870805"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c870805', __exports__)) {
    console.log('reload')
    api.reload('5c870805', __exports__)
  }
  
  module.hot.accept("./ReportHazards.vue?vue&type=template&id=5c870805", () => {
    console.log('re-render')
    api.rerender('5c870805', render)
  })

}


export default __exports__